"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AppStateConstants_1 = require("../../types/AppStateConstants");
const callableTogglePageLoader = ({ entryVars: { onlyDisable: onlyDisableEntry, lottie, }, store, }) => {
    if (onlyDisableEntry) {
        store.dispatch({
            type: AppStateConstants_1.AppStateConstants.LOADING_PAGE_REQUEST_CLOSE,
        });
    }
    else {
        const lottieUrl = typeof lottie === 'string' ? lottie : undefined;
        store.dispatch({
            type: AppStateConstants_1.AppStateConstants.LOADING_PAGE_REQUEST_OPEN,
            payload: {
                lottieUrl,
            },
        });
    }
};
exports.default = callableTogglePageLoader;
